/* converts string into hsl-value - is needed for tagging types
aka categories (website labeling) ss 02.2023 */
const colorstring = (inputString, saturation = 100, lightness = 35) => {
	let string = inputString;

	// Check if the string is undefined or null, and handle it accordingly
	if (typeof string !== 'string') {
		string = ''; // Set a default string value if input is undefined or not a string
	}

	let hash = 0;
	for (let i = 0; i < string.length; i += 1) {
		hash = string.charCodeAt(i) + 10;
	}
	return `hsl(${(hash % 360)}, ${saturation}%, ${lightness}%)`;
};

export default { colorstring };



// WEBPACK FOOTER //
// ./src/helper/colorHelper.js